const STORAGE_KEY = 'animationsPaused';
const isHomePage = window.location.href === 'https://shiftrobotics.io/' || window.location.pathname === '/';
const popupVideo = document.getElementById('video-popup');

document.querySelectorAll('img').forEach(function(img) {
  let alt = img.getAttribute('alt');
  if (!alt || alt.trim() === '') {
    let src = img.getAttribute('src');
    let filename = src.split('/').pop().split('?')[0]; 
    filename = filename.replace(/\.[^/.]+$/, "");     
    filename = filename.replace(/asset/gi, "");        
    filename = filename.replace(/\d+/g, "");          
    const altText = filename.replace(/-/g, ' ').replace(/\s+/g, ' ').trim() || "Image";
    img.setAttribute('alt', altText);
  }
});

const videos = Array.from(document.querySelectorAll('video'));

videos.forEach(video => {
  video.autoplay = false;
  
  if (!video.hasAttribute('controls')) {
    video.controls = false;
  }

  if (!isHomePage && !video.closest('.how-it-started')) {
    video.setAttribute('poster', '');
  }

  if(video.closest('#lightbox-video')){
    video.controls = true;
  }

  video.setAttribute('aria-hidden', 'true');
  video.setAttribute('role', 'presentation');
});


document.querySelectorAll('h2, h3, h4, h5, h6').forEach(el => {
  const hasRoleHeading = el.getAttribute('role') === 'heading';
  const hasAriaLevel2 = el.getAttribute('aria-level') === '2';

  if (!hasRoleHeading) {
    el.setAttribute('role', 'heading');
  }

  if (!hasAriaLevel2) {
    el.setAttribute('aria-level', '2');
  }
});


function playVideos() {
  videos.forEach(video => {
    if (video.autoplay) {
      video.muted = true;
      video.play().catch(()=>{});
    }
  });
}

function pauseVideos() {
  videos.forEach(video => {
    video.pause();
    video.autoplay = false;
  });
}

window.addEventListener('load', () => {
  const isPaused = localStorage.getItem(STORAGE_KEY) === 'true';

  if (!isPaused) {
    videos.forEach(video => video.autoplay = true);
    playVideos();
  } else {
    pauseVideos(); 
  }
});

window.addEventListener('load', () => {
  const btn = document.getElementById('pause-animations-toggle');
  if (!btn) return;

  setTimeout(() => {
    btn.classList.add('visible');
  }, 200);
});

window.addEventListener('load', () => {
  const iconLinks = document.querySelectorAll('a.header__icon');

  iconLinks.forEach(link => {
    const hasSVG = link.querySelector('svg');
    const hasText = link.textContent.trim().length > 0;

    if (hasSVG && !hasText) {
      if (link.classList.contains('header__icon--account')) {
        link.setAttribute('aria-label', 'Account');
      } else if (link.classList.contains('header__icon--cart')) {
        link.setAttribute('aria-label', 'Cart');
      } else {
        link.setAttribute('aria-label', 'Link');
      }

      const svg = link.querySelector('svg');
      if (svg) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    }
  });
});
